// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import "../css/DentalChartingScreen.css";
// import api from "../api/axiosConfig";
// import { useAuth } from "../context/AuthContext";

// // Import all tab components
// import DentalArch from "../components/charting/DentalArch";
// import ToothDiagram from "../components/charting/ToothDiagram";
// import ImageSelector from "../components/charting/ImageSelector";
// import ImageViewer from "../components/charting/ImageViewer";
// import DataEntryPopover, {
//   ParameterType,
// } from "../components/charting/DataEntryPopover";
// import ChartingSummary from "../components/charting/ChartingSummary";
// import CariogramTab from "../components/charting/CariogramTab";
// import ReportingTab from "../components/charting/ReportingTab";

// // Data Structures for Charting
// export interface SegmentData {
//   restoration: string | null;
//   caries: string | null;
//   activity: string | null;
// }
// export interface ToothChartingData {
//   isMissing: boolean;
//   missingCode: string | null;
//   segments: { [segmentId: number]: Partial<SegmentData> };
// }
// export type ChartingState = {
//   [toothId: number]: ToothChartingData;
// };
// export interface PopoverState {
//   x: number;
//   y: number;
//   toothId: number;
//   segmentId?: number;
//   parameterType: ParameterType;
// }

// type ActiveTab = "viewer" | "summary" | "cariogram" | "reporting";

// // ✅ Used for Save/Submit validation (same order as summary)
// const ALL_TEETH_IDS = [
//   55, 54, 53, 52, 51, 61, 62, 63, 64, 65, 85, 84, 83, 82, 81, 71, 72, 73, 74,
//   75,
// ];

// // Function to create default data for a tooth
// const createDefaultToothData = (): ToothChartingData => ({
//   isMissing: false,
//   missingCode: "P", // 'P' for Present
//   segments: {
//     1: { restoration: "0" },
//     2: { caries: "0" },
//     3: { activity: "-" },
//     4: { restoration: "0" },
//     5: { caries: "0" },
//     6: { activity: "-" },
//     7: { restoration: "0" },
//     8: { caries: "0" },
//     9: { activity: "-" },
//     10: { restoration: "0" },
//     11: { caries: "0" },
//     12: { activity: "-" },
//     13: { restoration: "0" },
//     14: { caries: "0" },
//     15: { activity: "-" },
//   },
// });

// // 🔧 TEMP: Static EMR ID for testing oral images
// const DentalChartingScreen: React.FC = () => {
//   // ✅ Map oralImages response key -> S3 module folder
//   const VIEW_TO_MODULE: Record<string, string> = {
//     Anterior: "oral-imaging/anterior",
//     "Right Buccal": "oral-imaging/right-buccal",
//     "Left Buccal": "oral-imaging/left-buccal",
//     "Maxillary Occlusal": "oral-imaging/maxillary",
//     "Mandibular Occlusal": "oral-imaging/mandibular",
//     // ✅ FIX casing to match backend key exactly
//     "Mallampati Score": "oral-imaging/mallampati",
//   };

//   // ✅ Map UI tab label -> oralImages key
//   const UI_VIEW_TO_DATA_KEY: Record<string, string> = {
//     Anterior: "Anterior",
//     "Right Buccal": "Right Buccal",
//     "Left Buccal": "Left Buccal",
//     "Maxillary Occlusal": "Maxillary Occlusal",
//     "Mandibular Occlusal": "Mandibular Occlusal",
//     "Mallampati Score": "Mallampati Score",
//   };

//   const { emrNumber } = useParams<{ emrNumber: string }>();
//   const navigate = useNavigate();

//   const effectiveEmrId = emrNumber;
//   const { doctor } = useAuth();

//   // const TEST_EMR_ID = "P-2026-000005-1";
//   // const effectiveEmrId = TEST_EMR_ID || emrNumber;

//   // const [selectedTooth, setSelectedTooth] = useState<number | null>(null);
// const [selectedTooth, setSelectedTooth] = useState<number | null>(55);
//   const [currentView, setCurrentView] = useState("Maxillary Occlusal");
//   const [chartingData, setChartingData] = useState<ChartingState>({});
//   const [popoverState, setPopoverState] = useState<PopoverState | null>(null);
//   const [activeTab, setActiveTab] = useState<ActiveTab>("viewer");
//   const [oralImages, setOralImages] = useState<{ [key: string]: string[] }>({});
//   // const [finalChartingData, setFinalChartingData] = useState<ChartingState>({});

//   const [signedImageMap, setSignedImageMap] = useState<
//     Record<string, string[]>
//   >({});

//   // ✅ NEW: Tracks which teeth are explicitly saved by the doctor
//   const [savedTeeth, setSavedTeeth] = useState<Set<number>>(new Set());
//   // ✅ NEW: track viewed tabs per tooth
//   // const [viewedTabs, setViewedTabs] = useState<Record<number, Set<string>>>({});
//   const [viewedTabs, setViewedTabs] = useState<Set<string>>(new Set());

//   useEffect(() => {
//     if (!effectiveEmrId) return;

//     const fetchOralImages = async () => {
//       try {
//         const res = await api.dataCollectionApi.get(
//           `/api/forms/oral-imaging/${effectiveEmrId}`,
//         );

//         if (res.data?.success && res.data?.data?.["Oral Imaging"]) {
//           setOralImages(res.data.data["Oral Imaging"]); // ✅ FIX
//         }
//       } catch (err) {
//         console.error("Failed to fetch oral imaging data:", err);
//       }
//     };

//     fetchOralImages();
//   }, [effectiveEmrId]);

//   /* ---------------- PRESIGNED URL FETCH (TELEDOCTOR: MODULE + PHOTO KEY) ---------------- */
//   useEffect(() => {
//     // if (!effectiveEmrId) return;

//     if (!oralImages || typeof oralImages !== "object") return;

//     const fetchSignedUrls = async () => {
//       const INTERNAL_TOKEN = "super-secret-password";
//       const map: Record<string, string[]> = {};

//       for (const [view, keys] of Object.entries(oralImages)) {
//         if (!Array.isArray(keys)) continue;

//         map[view] = [];

//         for (const fullPath of keys) {
//           try {
//             let module = "";
//             let key = "";

//             // A) full path exists: oral-imaging/<folder>/<...>
//             if (
//               typeof fullPath === "string" &&
//               fullPath.startsWith("oral-imaging/")
//             ) {
//               const parts = fullPath.split("/");
//               if (parts.length < 3) continue;

//               module = `${parts[0]}/${parts[1]}`;
//               key = parts.slice(2).join("/");
//             }
//             // B) only key exists -> use mapping
//             else {
//               module = VIEW_TO_MODULE[view] || "";
//               if (!module) continue;

//               key =
//                 typeof fullPath === "string" && fullPath.startsWith("/")
//                   ? fullPath.slice(1)
//                   : String(fullPath);
//             }

//             const res = await api.S3config.get("/view-url", {
//               params: { module, key },
//               headers: { "x-internal-token": INTERNAL_TOKEN },
//             });

//             if (res.data?.url) {
//               map[view].push(res.data.url);
//             }
//           } catch (err) {
//             console.error("Presign failed:", err);
//           }
//         }
//       }

//       setSignedImageMap(map);
//     };

//     if (Object.keys(oralImages).length > 0) {
//       fetchSignedUrls();
//     }
//   }, [oralImages]);

//   const getImageForView = () => {
//     if (!signedImageMap || !currentView) return "";

//     // ✅ Convert UI label -> actual oralImages key
//     const dataKey = UI_VIEW_TO_DATA_KEY[currentView] || currentView;

//     const images = signedImageMap[dataKey];
//     return Array.isArray(images) && images.length > 0 ? images[0] : "";
//   };

//   console.log(
//     "currentView:",
//     currentView,
//     "dataKey:",
//     UI_VIEW_TO_DATA_KEY[currentView] || currentView,
//   );
//   console.log("signed keys:", Object.keys(signedImageMap));
//   console.log("oralImages:", oralImages);
//   console.log("signedImageMap new:", signedImageMap);

//   // Effect to initialize data when a tooth is selected for the first time
//   useEffect(() => {
//     if (selectedTooth && !chartingData[selectedTooth]) {
//       setChartingData((prevData) => ({
//         ...prevData,
//         [selectedTooth]: createDefaultToothData(),
//       }));
//     }
//   }, [selectedTooth, chartingData]);

//   // ✅ Reset viewed tabs when new tooth selected
//   //   useEffect(() => {
//   //     if (!selectedTooth) return;

//   //   //   setViewedTabs((prev) => ({
//   //   //     ...prev,
//   //   //     [selectedTooth]: prev[selectedTooth] || new Set(),
//   //   //   }));
//   //   // }, [selectedTooth]);

//   //   setViewedTabs((prev) => {
//   //   const existing = prev[selectedTooth] || new Set();
//   //   const updated = new Set(existing);
//   //   updated.add(view);

//   //   return {
//   //     ...prev,
//   //     [selectedTooth]: updated,
//   //   };
//   // });

//   const getParameterTypeForSegment = (segmentId: number): ParameterType => {
//     if ([1, 4, 7, 10, 13].includes(segmentId)) return "Restoration";
//     if ([2, 5, 8, 11, 14].includes(segmentId)) return "Caries";
//     return "Activity";
//   };

//   // const handleSegmentClick = (
//   //   segmentId: number,
//   //   event: React.MouseEvent<HTMLButtonElement>,
//   // ) => {
//   //   if (!selectedTooth) return;

//   //   const { x, y } = getPopoverPosition();
//   //   const parameterType = getParameterTypeForSegment(segmentId);

//   //   setPopoverState({
//   //     x,
//   //     y,
//   //     toothId: selectedTooth,
//   //     segmentId,
//   //     parameterType,
//   //   });
//   // };



//   const handleSegmentClick = (
//   segmentId: number,
//   event: React.MouseEvent<HTMLButtonElement>
// ) => {
//   if (!selectedTooth) return;

//   // 🔥 CHECK IMAGES FIRST
//   const notViewed = REQUIRED_VIEWS.filter((v) => !viewedTabs.has(v));

//   if (notViewed.length > 0) {
//     alert(
//       `⚠️ Please view all required images before entering tooth data.\n\nMissing:\n${notViewed.join(
//         ", "
//       )}`
//     );
//     return;
//   }

//   const { x, y } = getPopoverPosition();
//   const parameterType = getParameterTypeForSegment(segmentId);

//   setPopoverState({
//     x,
//     y,
//     toothId: selectedTooth,
//     segmentId,
//     parameterType,
//   });
// };

//   const getPopoverPosition = () => {
//     const chartingContent = document.querySelector(
//       ".charting-content",
//     ) as HTMLElement;

//     const rightColumn = document.querySelector(
//       ".right-charting-column",
//     ) as HTMLElement;

//     if (!chartingContent || !rightColumn) {
//       return { x: 0, y: 0 };
//     }

//     const containerRect = chartingContent.getBoundingClientRect();
//     const rightRect = rightColumn.getBoundingClientRect();

//     return {
//       x: Math.min(
//         rightRect.right - containerRect.left + 10,
//         containerRect.width - 190, // popover width (220) + buffer
//       ),
//       y: Math.max(rightRect.top - containerRect.top + rightRect.height / 4, 10),
//     };
//   };

//   // const handleMissingToothClick = () => {
//   //   if (!selectedTooth) return;

//   //   const { x, y } = getPopoverPosition();

//   //   setPopoverState({
//   //     x,
//   //     y,
//   //     toothId: selectedTooth,
//   //     parameterType: "Missing",
//   //   });
//   // };


//   const handleMissingToothClick = () => {
//   if (!selectedTooth) return;

//   const notViewed = REQUIRED_VIEWS.filter((v) => !viewedTabs.has(v));

//   if (notViewed.length > 0) {
//     alert(
//       `⚠️ Please view all required images before entering tooth data.\n\nMissing:\n${notViewed.join(
//         ", "
//       )}`
//     );
//     return;
//   }

//   const { x, y } = getPopoverPosition();

//   setPopoverState({
//     x,
//     y,
//     toothId: selectedTooth,
//     parameterType: "Missing",
//   });
// };

//   const handlePopoverSave = (value: string) => {
//     if (!popoverState) return;
//     const { toothId, segmentId, parameterType } = popoverState;

//     setChartingData((prevData) => {
//       const newData = JSON.parse(JSON.stringify(prevData));
//       if (!newData[toothId]) {
//         newData[toothId] = createDefaultToothData();
//       }

//       if (parameterType === "Missing") {
//         const wasMissing = prevData[toothId]?.isMissing === true;
//         const isNowMissing = value !== "P" && value !== "";

//         newData[toothId].isMissing = isNowMissing;
//         newData[toothId].missingCode = value || "P";

//         if (isNowMissing) {
//           // If tooth is marked as missing, clear its segment data
//           newData[toothId].segments = {};
//         } else if (wasMissing && !isNowMissing) {
//           // If tooth is being marked as present (was missing), restore default segments
//           newData[toothId].segments = createDefaultToothData().segments;
//         }
//       } else if (segmentId) {
//         if (!newData[toothId].segments[segmentId]) {
//           newData[toothId].segments[segmentId] = {};
//         }
//         const paramKey = parameterType.toLowerCase() as keyof SegmentData;
//         newData[toothId].segments[segmentId][paramKey] = value;
//       }
//       return newData;
//     });

//     setPopoverState(null);
//   };

//   // ✅ REQUIRED VIEWS
//   const REQUIRED_VIEWS = [
//     "Anterior",
//     "Right Buccal",
//     "Left Buccal",
//     "Maxillary Occlusal",
//     "Mandibular Occlusal",
//   ];

//   const viewedCount = REQUIRED_VIEWS.filter((v) =>
//   viewedTabs.has(v)
// ).length;

 

// const handleSaveTooth = () => {
//   if (!selectedTooth) {
//     alert("Please select a tooth to save.");
//     return;
//   }

//   // 🔥 NEW: CHECK REQUIRED IMAGES
//   const notViewed = REQUIRED_VIEWS.filter((v) => !viewedTabs.has(v));

//   if (notViewed.length > 0) {
//     alert(
//       `⚠️ Please view all required images before saving.\n\nMissing:\n${notViewed.join(
//         ", "
//       )}`
//     );
//     return;
//   }

//   // ✅ Ensure tooth exists
//   setChartingData((prevData) => {
//     if (prevData[selectedTooth]) return prevData;
//     return { ...prevData, [selectedTooth]: createDefaultToothData() };
//   });

//   // ✅ Mark as saved
//   setSavedTeeth((prev) => {
//     const next = new Set(prev);
//     next.add(selectedTooth);
//     return next;
//   });

//   console.log("Saved tooth:", selectedTooth);
// };




// const handleSubmit = async () => {
//   // ✅ 1. Check all teeth saved
//   const missing = ALL_TEETH_IDS.filter((id) => !savedTeeth.has(id));

//   if (missing.length > 0) {
//     alert(
//       `Please fill and Save Tooth for the following teeth:\n\n${missing.join(
//         ", "
//       )}`
//     );
//     return;
//   }

//   // ✅ 2. Check ALL images viewed (GLOBAL)
//   const notViewed = REQUIRED_VIEWS.filter((v) => !viewedTabs.has(v));

//   if (notViewed.length > 0) {
//     alert(
//       `Please view all required images before submitting:\n\n${notViewed.join(
//         ", "
//       )}`
//     );
//     return;
//   }

//   try {
//     const payload = {
//       patientId: effectiveEmrId,
//       chartType: "primary",
//       createdBy: doctor ? `Dr. ${doctor.name}` : null,
//       teeth: chartingData,
//     };

//     console.log("Submitting Dental Chart Payload:", payload);

//     await api.dataCollectionApi.post("/api/teledocs/dental/chart", payload);

//     setActiveTab("summary");
//   } catch (error) {
//     console.error("Failed to save dental charting data:", error);
//     alert("Failed to save dental charting data. Please try again.");
//   }
// };



//   const handleResetCurrentTooth = () => {
//     if (!selectedTooth) {
//       alert("Please select a tooth to reset.");
//       return;
//     }

//     setChartingData((prevData) => {
//       const newData = { ...prevData };
//       if (newData[selectedTooth]) {
//         delete newData[selectedTooth];
//       }
//       return newData;
//     });

//     // ✅ also remove from saved list
//     setSavedTeeth((prev) => {
//       const next = new Set(prev);
//       next.delete(selectedTooth);
//       return next;
//     });

//     setSelectedTooth(null);
//   };

//   const getCurrentValueForPopover = (): string | null => {
//     if (!popoverState) return null;
//     const { toothId, segmentId, parameterType } = popoverState;
//     if (!chartingData[toothId]) return null;

//     if (parameterType === "Missing") {
//       return chartingData[toothId]?.missingCode || "P";
//     }
//     if (segmentId) {
//       const paramKey = parameterType.toLowerCase() as keyof SegmentData;
//       return chartingData[toothId]?.segments[segmentId]?.[paramKey] || null;
//     }
//     return null;
//   };

//   const renderActiveTab = () => {
//     switch (activeTab) {
//       case "viewer":
//         return (
//           <div className="single-charting-layout">
//             {/* 1️⃣ ARCH FIRST */}

//             <div className="arch-wrapper">
//               {/* <DentalArch
//                 onToothSelect={setSelectedTooth}
//                 selectedTooth={selectedTooth}
//                 chartingData={chartingData}
//               /> */}


//               <DentalArch
//   onToothSelect={setSelectedTooth}
//   selectedTooth={selectedTooth}
//   chartingData={chartingData}
//   savedTeeth={savedTeeth}
//   viewedTabs={viewedTabs}
// />
//             </div>

//             {/* 2️⃣ IMAGE SECOND */}
//             <div className="image-section">
//               <ImageSelector
//                 currentView={currentView}
//                 // onViewChange={setCurrentView}
//                  viewedTabs={viewedTabs}          // ✅ NEW
//   requiredViews={REQUIRED_VIEWS}   // ✅ NEW
//                 onViewChange={(view) => {
//                   setCurrentView(view);

//                   if (!selectedTooth) return;

//                   // setViewedTabs((prev) => {
//                   //   const existing = prev[selectedTooth] || new Set();
//                   //   const updated = new Set(existing);
//                   //   updated.add(view);

//                   //   return {
//                   //     ...prev,
//                   //     [selectedTooth]: updated,
//                   //   };
//                   // });

//                   setViewedTabs((prev) => {
//                     const updated = new Set(prev);
//                     updated.add(view);
//                     return updated;
//                   });
//                 }}
//               />
//               <div className="image-progress">
//   Viewed Images: {viewedCount} / {REQUIRED_VIEWS.length}
// </div>
//               <ImageViewer imageSrc={getImageForView()} />
//             </div>

//             {/* 3️⃣ TOOTH THIRD */}
//             <div className="tooth-diagram-section">
//               <ToothDiagram
//                 toothId={selectedTooth}
//                 chartingData={
//                   selectedTooth ? chartingData[selectedTooth] : undefined
//                 }
//                 onSegmentClick={handleSegmentClick}
//                 onMissingToothClick={handleMissingToothClick}
//               />

//               <div className="tooth-actions">
//                 <button onClick={handleSaveTooth} className="submit-btn">
//                   Save Tooth
//                 </button>
//               </div>
//             </div>

//             {/* 4️⃣ BUTTONS LAST */}
//             <div className="submission-buttons">
//               <button onClick={handleSubmit} className="submit-btn">
//                 Submit
//               </button>
//               <button onClick={handleResetCurrentTooth} className="reset-btn">
//                 Reset
//               </button>
//             </div>
//           </div>
//         );

//       case "summary":
//         return (
//           <ChartingSummary
//             chartingData={chartingData}
//             onSubmitSuccess={() => setActiveTab("cariogram")}
//           />
//         );

//       case "cariogram":
//         return (
//           <CariogramTab
//             chartingData={chartingData}
//             onSubmitSuccess={() => setActiveTab("reporting")}
//           />
//         );

//       case "reporting":
//         return <ReportingTab chartingData={chartingData} />;

//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="charting-screen">
//       <div className="screen-header-row">
//         <button
//           onClick={() => navigate("/queue/teledental")}
//           className="back-button"
//         >
//           &larr; Back to Patient List
//         </button>
//         <div className="patient-info-details">
//           <span>
//             <strong>EMR Number:</strong> {emrNumber}
//           </span>
//           <span>
//             <strong>Age:</strong> 3 Years, 2 Months
//           </span>
//         </div>
//       </div>

//       <div className="tabs-container">
//         <button
//           className={`tab ${activeTab === "viewer" ? "active" : ""}`}
//           onClick={() => setActiveTab("viewer")}
//         >
//           Dental Image Viewer and Charting
//         </button>
//         <button
//           className={`tab ${activeTab === "summary" ? "active" : ""}`}
//           onClick={() => setActiveTab("summary")}
//         >
//           Online Charting Summary
//         </button>
//         <button
//           className={`tab ${activeTab === "cariogram" ? "active" : ""}`}
//           onClick={() => setActiveTab("cariogram")}
//         >
//           Cariogram Input & ICCMS Risk Assessment
//         </button>
//         <button
//           className={`tab ${activeTab === "reporting" ? "active" : ""}`}
//           onClick={() => setActiveTab("reporting")}
//         >
//           Reporting
//         </button>
//       </div>

//       <div className="charting-content">
//         {renderActiveTab()}

//         {popoverState && (
//           <DataEntryPopover
//             x={popoverState.x}
//             y={popoverState.y}
//             onClose={() => setPopoverState(null)}
//             onSave={handlePopoverSave}
//             parameterType={popoverState.parameterType}
//             currentValue={getCurrentValueForPopover()}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default DentalChartingScreen;




















import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../css/DentalChartingScreen.css";
import api from "../api/axiosConfig";
import { useAuth } from "../context/AuthContext";

// Import all tab components
import DentalArch from "../components/charting/DentalArch";
import ToothDiagram from "../components/charting/ToothDiagram";
import ImageSelector from "../components/charting/ImageSelector";
import ImageViewer from "../components/charting/ImageViewer";
import DataEntryPopover, {
  ParameterType,
} from "../components/charting/DataEntryPopover";
import ChartingSummary from "../components/charting/ChartingSummary";
import CariogramTab from "../components/charting/CariogramTab";
import ReportingTab from "../components/charting/ReportingTab";

// Data Structures for Charting
export interface SegmentData {
  restoration: string | null;
  caries: string | null;
  activity: string | null;
}
export interface ToothChartingData {
  isMissing: boolean;
  missingCode: string | null;
  segments: { [segmentId: number]: Partial<SegmentData> };
}
export type ChartingState = {
  [toothId: number]: ToothChartingData;
};
export interface PopoverState {
  x: number;
  y: number;
  toothId: number;
  segmentId?: number;
  parameterType: ParameterType;
}

type ActiveTab = "viewer" | "summary" | "cariogram" | "reporting";

// ✅ Used for Save/Submit validation (same order as summary)
const ALL_TEETH_IDS = [
  55, 54, 53, 52, 51, 61, 62, 63, 64, 65, 85, 84, 83, 82, 81, 71, 72, 73, 74,
  75,
];

// Function to create default data for a tooth
const createDefaultToothData = (): ToothChartingData => ({
  isMissing: false,
  missingCode: "P", // 'P' for Present
  segments: {
    1: { restoration: "0" },
    2: { caries: "0" },
    3: { activity: "-" },
    4: { restoration: "0" },
    5: { caries: "0" },
    6: { activity: "-" },
    7: { restoration: "0" },
    8: { caries: "0" },
    9: { activity: "-" },
    10: { restoration: "0" },
    11: { caries: "0" },
    12: { activity: "-" },
    13: { restoration: "0" },
    14: { caries: "0" },
    15: { activity: "-" },
  },
});

// 🔧 TEMP: Static EMR ID for testing oral images
const DentalChartingScreen: React.FC = () => {
  // ✅ Map oralImages response key -> S3 module folder
  const VIEW_TO_MODULE: Record<string, string> = {
    Anterior: "oral-imaging/anterior",
    "Right Buccal": "oral-imaging/right-buccal",
    "Left Buccal": "oral-imaging/left-buccal",
    "Maxillary Occlusal": "oral-imaging/maxillary",
    "Mandibular Occlusal": "oral-imaging/mandibular",
    // ✅ FIX casing to match backend key exactly
    "Mallampati Score": "oral-imaging/mallampati",
  };

  // ✅ Map UI tab label -> oralImages key
  const UI_VIEW_TO_DATA_KEY: Record<string, string> = {
    Anterior: "Anterior",
    "Right Buccal": "Right Buccal",
    "Left Buccal": "Left Buccal",
    "Maxillary Occlusal": "Maxillary Occlusal",
    "Mandibular Occlusal": "Mandibular Occlusal",
    "Mallampati Score": "Mallampati Score",
  };

  const { emrNumber } = useParams<{ emrNumber: string }>();
  const navigate = useNavigate();

  const effectiveEmrId = emrNumber;
  const { doctor } = useAuth();

  // const TEST_EMR_ID = "P-2026-000005-1";
  // const effectiveEmrId = TEST_EMR_ID || emrNumber;

  // const [selectedTooth, setSelectedTooth] = useState<number | null>(null);
const [selectedTooth, setSelectedTooth] = useState<number | null>(55);
  // const [currentView, setCurrentView] = useState("Maxillary Occlusal");
  const [currentView, setCurrentView] = useState("Anterior"); 
  const [chartingData, setChartingData] = useState<ChartingState>({});
  const [popoverState, setPopoverState] = useState<PopoverState | null>(null);
  const [activeTab, setActiveTab] = useState<ActiveTab>("viewer");
  const [oralImages, setOralImages] = useState<{ [key: string]: string[] }>({});
  // const [finalChartingData, setFinalChartingData] = useState<ChartingState>({});

  const [signedImageMap, setSignedImageMap] = useState<
    Record<string, string[]>
  >({});

  // ✅ NEW: Tracks which teeth are explicitly saved by the doctor
  const [savedTeeth, setSavedTeeth] = useState<Set<number>>(new Set());
  // ✅ NEW: track viewed tabs per tooth
  // const [viewedTabs, setViewedTabs] = useState<Record<number, Set<string>>>({});
  // const [viewedTabs, setViewedTabs] = useState<Set<string>>(new Set());
const [viewedTabs, setViewedTabs] = useState<Set<string>>(
  new Set(["Anterior"]) // ✅ already viewed
);
  useEffect(() => {
    if (!effectiveEmrId) return;

    const fetchOralImages = async () => {
      try {
        const res = await api.dataCollectionApi.get(
          `/api/forms/oral-imaging/${effectiveEmrId}`,
        );

        if (res.data?.success && res.data?.data?.["Oral Imaging"]) {
          setOralImages(res.data.data["Oral Imaging"]); // ✅ FIX
        }
      } catch (err) {
        console.error("Failed to fetch oral imaging data:", err);
      }
    };

    fetchOralImages();
  }, [effectiveEmrId]);

  /* ---------------- PRESIGNED URL FETCH (TELEDOCTOR: MODULE + PHOTO KEY) ---------------- */
  useEffect(() => {
    // if (!effectiveEmrId) return;

    if (!oralImages || typeof oralImages !== "object") return;

    const fetchSignedUrls = async () => {
      const INTERNAL_TOKEN = "super-secret-password";
      const map: Record<string, string[]> = {};

      for (const [view, keys] of Object.entries(oralImages)) {
        if (!Array.isArray(keys)) continue;

        map[view] = [];

        for (const fullPath of keys) {
          try {
            let module = "";
            let key = "";

            // A) full path exists: oral-imaging/<folder>/<...>
            if (
              typeof fullPath === "string" &&
              fullPath.startsWith("oral-imaging/")
            ) {
              const parts = fullPath.split("/");
              if (parts.length < 3) continue;

              module = `${parts[0]}/${parts[1]}`;
              key = parts.slice(2).join("/");
            }
            // B) only key exists -> use mapping
            else {
              module = VIEW_TO_MODULE[view] || "";
              if (!module) continue;

              key =
                typeof fullPath === "string" && fullPath.startsWith("/")
                  ? fullPath.slice(1)
                  : String(fullPath);
            }

            const res = await api.S3config.get("/view-url", {
              params: { module, key },
              headers: { "x-internal-token": INTERNAL_TOKEN },
            });

            if (res.data?.url) {
              map[view].push(res.data.url);
            }
          } catch (err) {
            console.error("Presign failed:", err);
          }
        }
      }

      setSignedImageMap(map);
    };

    if (Object.keys(oralImages).length > 0) {
      fetchSignedUrls();
    }
  }, [oralImages]);

  const getImageForView = () => {
    if (!signedImageMap || !currentView) return "";

    // ✅ Convert UI label -> actual oralImages key
    const dataKey = UI_VIEW_TO_DATA_KEY[currentView] || currentView;

    const images = signedImageMap[dataKey];
    return Array.isArray(images) && images.length > 0 ? images[0] : "";
  };

  console.log(
    "currentView:",
    currentView,
    "dataKey:",
    UI_VIEW_TO_DATA_KEY[currentView] || currentView,
  );
  console.log("signed keys:", Object.keys(signedImageMap));
  console.log("oralImages:", oralImages);
  console.log("signedImageMap new:", signedImageMap);

  // Effect to initialize data when a tooth is selected for the first time
  useEffect(() => {
    if (selectedTooth && !chartingData[selectedTooth]) {
      setChartingData((prevData) => ({
        ...prevData,
        [selectedTooth]: createDefaultToothData(),
      }));
    }
  }, [selectedTooth, chartingData]);

  // ✅ Reset viewed tabs when new tooth selected
  //   useEffect(() => {
  //     if (!selectedTooth) return;

  //   //   setViewedTabs((prev) => ({
  //   //     ...prev,
  //   //     [selectedTooth]: prev[selectedTooth] || new Set(),
  //   //   }));
  //   // }, [selectedTooth]);

  //   setViewedTabs((prev) => {
  //   const existing = prev[selectedTooth] || new Set();
  //   const updated = new Set(existing);
  //   updated.add(view);

  //   return {
  //     ...prev,
  //     [selectedTooth]: updated,
  //   };
  // });

  const getParameterTypeForSegment = (segmentId: number): ParameterType => {
    if ([1, 4, 7, 10, 13].includes(segmentId)) return "Restoration";
    if ([2, 5, 8, 11, 14].includes(segmentId)) return "Caries";
    return "Activity";
  };

  // const handleSegmentClick = (
  //   segmentId: number,
  //   event: React.MouseEvent<HTMLButtonElement>,
  // ) => {
  //   if (!selectedTooth) return;

  //   const { x, y } = getPopoverPosition();
  //   const parameterType = getParameterTypeForSegment(segmentId);

  //   setPopoverState({
  //     x,
  //     y,
  //     toothId: selectedTooth,
  //     segmentId,
  //     parameterType,
  //   });
  // };



  const handleSegmentClick = (
  segmentId: number,
  event: React.MouseEvent<HTMLButtonElement>
) => {
  if (!selectedTooth) return;

  // 🔥 CHECK IMAGES FIRST
  // const notViewed = REQUIRED_VIEWS.filter((v) => !viewedTabs.has(v));
const notViewed = getNotViewedImages();
  if (notViewed.length > 0) {
    alert(
      `⚠️ Please view all required images before entering tooth data.\n\nMissing:\n${notViewed.join(
        ", "
      )}`
    );
    return;
  }

  const { x, y } = getPopoverPosition();
  const parameterType = getParameterTypeForSegment(segmentId);

  setPopoverState({
    x,
    y,
    toothId: selectedTooth,
    segmentId,
    parameterType,
  });
};

  const getPopoverPosition = () => {
    const chartingContent = document.querySelector(
      ".charting-content",
    ) as HTMLElement;

    const rightColumn = document.querySelector(
      ".right-charting-column",
    ) as HTMLElement;

    if (!chartingContent || !rightColumn) {
      return { x: 0, y: 0 };
    }

    const containerRect = chartingContent.getBoundingClientRect();
    const rightRect = rightColumn.getBoundingClientRect();

    return {
      x: Math.min(
        rightRect.right - containerRect.left + 10,
        containerRect.width - 190, // popover width (220) + buffer
      ),
      y: Math.max(rightRect.top - containerRect.top + rightRect.height / 4, 10),
    };
  };

  // const handleMissingToothClick = () => {
  //   if (!selectedTooth) return;

  //   const { x, y } = getPopoverPosition();

  //   setPopoverState({
  //     x,
  //     y,
  //     toothId: selectedTooth,
  //     parameterType: "Missing",
  //   });
  // };


  const handleMissingToothClick = () => {
  if (!selectedTooth) return;

  // const notViewed = REQUIRED_VIEWS.filter((v) => !viewedTabs.has(v));
const notViewed = getNotViewedImages();
  if (notViewed.length > 0) {
    alert(
      `⚠️ Please view all required images before entering tooth data.\n\nMissing:\n${notViewed.join(
        ", "
      )}`
    );
    return;
  }

  const { x, y } = getPopoverPosition();

  setPopoverState({
    x,
    y,
    toothId: selectedTooth,
    parameterType: "Missing",
  });
};

  const handlePopoverSave = (value: string) => {
    if (!popoverState) return;
    const { toothId, segmentId, parameterType } = popoverState;

    setChartingData((prevData) => {
      const newData = JSON.parse(JSON.stringify(prevData));
      if (!newData[toothId]) {
        newData[toothId] = createDefaultToothData();
      }

      if (parameterType === "Missing") {
        const wasMissing = prevData[toothId]?.isMissing === true;
        const isNowMissing = value !== "P" && value !== "";

        newData[toothId].isMissing = isNowMissing;
        newData[toothId].missingCode = value || "P";

        if (isNowMissing) {
          // If tooth is marked as missing, clear its segment data
          newData[toothId].segments = {};
        } else if (wasMissing && !isNowMissing) {
          // If tooth is being marked as present (was missing), restore default segments
          newData[toothId].segments = createDefaultToothData().segments;
        }
      } else if (segmentId) {
        if (!newData[toothId].segments[segmentId]) {
          newData[toothId].segments[segmentId] = {};
        }
        const paramKey = parameterType.toLowerCase() as keyof SegmentData;
        newData[toothId].segments[segmentId][paramKey] = value;
      }
      return newData;
    });

    setPopoverState(null);
  };

  // ✅ REQUIRED VIEWS
  const REQUIRED_VIEWS = [
    "Anterior",
    "Right Buccal",
    "Left Buccal",
    "Maxillary Occlusal",
    "Mandibular Occlusal",
  ];

  const viewedCount = REQUIRED_VIEWS.filter((v) =>
  viewedTabs.has(v)
).length;

  // const viewed = viewedTabs[selectedTooth] || new Set();

  // ✅ NEW: Save Tooth button logic
//   const handleSaveTooth = () => {
//     if (!selectedTooth) return;

//     // const viewed = viewedTabs[selectedTooth] || new Set<string>();
//     // const viewed = viewedTabs;
//     const viewed = viewedTabs instanceof Set ? viewedTabs : new Set<string>();
//     console.log("viewedTabs type:", viewedTabs);

//     const notViewed = REQUIRED_VIEWS.filter((v) => !viewed.has(v));

//     if (notViewed.length > 0) {
//       alert(
//         `Please view all required images before saving:\n\n${notViewed.join(", ")}`,
//       );
//       return;
//     }

//     // ✅ ADD THIS (VERY IMPORTANT)
//     // setViewedTabs((prev) => {
//     //   const updated = { ...prev };
//     //   delete updated[selectedTooth!];
//     //   return updated;
//     // });

//     setViewedTabs((prev) => ({
//   ...prev,
//   [selectedTooth]: new Set(),
// }));

//     if (!selectedTooth) {
//       alert("Please select a tooth to save.");
//       return;
//     }

//     setViewedTabs((prev) => ({
//       ...prev,
//       [selectedTooth]: new Set(),
//     }));

//     // Ensure tooth exists in chartingData
//     setChartingData((prevData) => {
//       if (prevData[selectedTooth]) return prevData;
//       return { ...prevData, [selectedTooth]: createDefaultToothData() };
//     });

//     setSavedTeeth((prev) => {
//       const next = new Set(prev);
//       next.add(selectedTooth);
//       return next;
//     });

//     console.log("Saved tooth:", selectedTooth);
//   };



// const handleSaveTooth = () => {
//   if (!selectedTooth) {
//     alert("Please select a tooth to save.");
//     return;
//   }

//   // ✅ NO IMAGE VALIDATION HERE

//   // Ensure tooth exists
//   setChartingData((prevData) => {
//     if (prevData[selectedTooth]) return prevData;
//     return { ...prevData, [selectedTooth]: createDefaultToothData() };
//   });

//   // Mark as saved
//   setSavedTeeth((prev) => {
//     const next = new Set(prev);
//     next.add(selectedTooth);
//     return next;
//   });

//   console.log("Saved tooth:", selectedTooth);
// };



const handleSaveTooth = () => {
  if (!selectedTooth) {
    alert("Please select a tooth to save.");
    return;
  }

  // 🔥 NEW: CHECK REQUIRED IMAGES
  // const notViewed = REQUIRED_VIEWS.filter((v) => !viewedTabs.has(v));

  const notViewed = getNotViewedImages();
  if (notViewed.length > 0) {
    alert(
      `⚠️ Please view all required images before saving.\n\nMissing:\n${notViewed.join(
        ", "
      )}`
    );
    return;
  }

  // ✅ Ensure tooth exists
  setChartingData((prevData) => {
    if (prevData[selectedTooth]) return prevData;
    return { ...prevData, [selectedTooth]: createDefaultToothData() };
  });

  // ✅ Mark as saved
  setSavedTeeth((prev) => {
    const next = new Set(prev);
    next.add(selectedTooth);
    return next;
  });

  console.log("Saved tooth:", selectedTooth);
};



  // const handleSubmit = async () => {
  //   // ✅ Validate: All teeth must be explicitly saved
  //   const missing = ALL_TEETH_IDS.filter((id) => !savedTeeth.has(id));

  //   if (missing.length > 0) {
  //     alert(
  //       `Please fill and Save Tooth for the following missing teeth:\n\n${missing.join(
  //         ", ",
  //       )}`,
  //     );
  //     return;
  //   }

  //   try {
  //     // 🔹 Build payload exactly as backend expects
  //     const payload = {
  //       patientId: effectiveEmrId, // EMR / Patient ID
  //       chartType: "primary",
  //       // createdBy: "doctor_123", // TODO: replace later with logged-in doctor
  //       createdBy: doctor ? `Dr. ${doctor.name}` : null,
  //       teeth: chartingData,
  //     };

  //     console.log("Submitting Dental Chart Payload:", payload);

  //     // 🔹 Save to Data Collection MS
  //     await api.dataCollectionApi.post("/api/teledocs/dental/chart", payload);

  //     // 🔹 Move to summary tab after successful save
  //     setActiveTab("summary");
  //   } catch (error) {
  //     console.error("Failed to save dental charting data:", error);
  //     alert("Failed to save dental charting data. Please try again.");
  //   }
  // };

const getNotViewedImages = () => {
  return REQUIRED_VIEWS
    .filter((v) => v !== "Anterior") // ✅ ignore default
    .filter((v) => !viewedTabs.has(v));
};

const handleSubmit = async () => {
  // ✅ 1. Check all teeth saved
  const missing = ALL_TEETH_IDS.filter((id) => !savedTeeth.has(id));

  if (missing.length > 0) {
    alert(
      `Please fill and Save Tooth for the following teeth:\n\n${missing.join(
        ", "
      )}`
    );
    return;
  }

  // ✅ 2. Check ALL images viewed (GLOBAL)
  // const notViewed = REQUIRED_VIEWS.filter((v) => !viewedTabs.has(v));
const notViewed = getNotViewedImages();
  if (notViewed.length > 0) {
    alert(
      `Please view all required images before submitting:\n\n${notViewed.join(
        ", "
      )}`
    );
    return;
  }

  try {
    const payload = {
      patientId: effectiveEmrId,
      chartType: "primary",
      createdBy: doctor ? `Dr. ${doctor.name}` : null,
      teeth: chartingData,
    };

    console.log("Submitting Dental Chart Payload:", payload);

    await api.dataCollectionApi.post("/api/teledocs/dental/chart", payload);

    setActiveTab("summary");
  } catch (error) {
    console.error("Failed to save dental charting data:", error);
    alert("Failed to save dental charting data. Please try again.");
  }
};



  const handleResetCurrentTooth = () => {
    if (!selectedTooth) {
      alert("Please select a tooth to reset.");
      return;
    }

    setChartingData((prevData) => {
      const newData = { ...prevData };
      if (newData[selectedTooth]) {
        delete newData[selectedTooth];
      }
      return newData;
    });

    // ✅ also remove from saved list
    setSavedTeeth((prev) => {
      const next = new Set(prev);
      next.delete(selectedTooth);
      return next;
    });

    setSelectedTooth(null);
  };

  const getCurrentValueForPopover = (): string | null => {
    if (!popoverState) return null;
    const { toothId, segmentId, parameterType } = popoverState;
    if (!chartingData[toothId]) return null;

    if (parameterType === "Missing") {
      return chartingData[toothId]?.missingCode || "P";
    }
    if (segmentId) {
      const paramKey = parameterType.toLowerCase() as keyof SegmentData;
      return chartingData[toothId]?.segments[segmentId]?.[paramKey] || null;
    }
    return null;
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case "viewer":
        return (
          <div className="single-charting-layout">
            {/* 1️⃣ ARCH FIRST */}

            <div className="arch-wrapper">
              {/* <DentalArch
                onToothSelect={setSelectedTooth}
                selectedTooth={selectedTooth}
                chartingData={chartingData}
              /> */}


              <DentalArch
  onToothSelect={setSelectedTooth}
  selectedTooth={selectedTooth}
  chartingData={chartingData}
  savedTeeth={savedTeeth}
  viewedTabs={viewedTabs}
/>
            </div>

            {/* 2️⃣ IMAGE SECOND */}
            <div className="image-section">
              <ImageSelector
                currentView={currentView}
                // onViewChange={setCurrentView}
                 viewedTabs={viewedTabs}          // ✅ NEW
  requiredViews={REQUIRED_VIEWS}   // ✅ NEW
                onViewChange={(view) => {
                  setCurrentView(view);

                  if (!selectedTooth) return;

                  // setViewedTabs((prev) => {
                  //   const existing = prev[selectedTooth] || new Set();
                  //   const updated = new Set(existing);
                  //   updated.add(view);

                  //   return {
                  //     ...prev,
                  //     [selectedTooth]: updated,
                  //   };
                  // });

                  setViewedTabs((prev) => {
                    const updated = new Set(prev);
                    updated.add(view);
                    return updated;
                  });
                }}
              />
              <div className="image-progress">
  Viewed Images: {viewedCount} / {REQUIRED_VIEWS.length}
</div>
              <ImageViewer imageSrc={getImageForView()} />
            </div>

            {/* 3️⃣ TOOTH THIRD */}
            <div className="tooth-diagram-section">
              <ToothDiagram
                toothId={selectedTooth}
                chartingData={
                  selectedTooth ? chartingData[selectedTooth] : undefined
                }
                onSegmentClick={handleSegmentClick}
                onMissingToothClick={handleMissingToothClick}
              />

              <div className="tooth-actions">
                <button onClick={handleSaveTooth} className="submit-btn">
                  Save Tooth
                </button>
              </div>
            </div>

            {/* 4️⃣ BUTTONS LAST */}
            <div className="submission-buttons">
              <button onClick={handleSubmit} className="submit-btn">
                Submit
              </button>
              <button onClick={handleResetCurrentTooth} className="reset-btn">
                Reset
              </button>
            </div>
          </div>
        );

      case "summary":
        return (
          <ChartingSummary
            chartingData={chartingData}
            onSubmitSuccess={() => setActiveTab("cariogram")}
          />
        );

      case "cariogram":
        return (
          <CariogramTab
            chartingData={chartingData}
            onSubmitSuccess={() => setActiveTab("reporting")}
          />
        );

      case "reporting":
        return <ReportingTab chartingData={chartingData} />;

      default:
        return null;
    }
  };

  return (
    <div className="charting-screen">
      <div className="screen-header-row">
        <button
          onClick={() => navigate("/queue/teledental")}
          className="back-button"
        >
          &larr; Back to Patient List
        </button>
        <div className="patient-info-details">
          <span>
            <strong>EMR Number:</strong> {emrNumber}
          </span>
          <span>
            <strong>Age:</strong> 3 Years, 2 Months
          </span>
        </div>
      </div>

      <div className="tabs-container">
        <button
          className={`tab ${activeTab === "viewer" ? "active" : ""}`}
          onClick={() => setActiveTab("viewer")}
        >
          Dental Image Viewer and Charting
        </button>
        <button
          className={`tab ${activeTab === "summary" ? "active" : ""}`}
          onClick={() => setActiveTab("summary")}
        >
          Online Charting Summary
        </button>
        <button
          className={`tab ${activeTab === "cariogram" ? "active" : ""}`}
          onClick={() => setActiveTab("cariogram")}
        >
          Cariogram Input & ICCMS Risk Assessment
        </button>
        <button
          className={`tab ${activeTab === "reporting" ? "active" : ""}`}
          onClick={() => setActiveTab("reporting")}
        >
          Reporting
        </button>
      </div>

      <div className="charting-content">
        {renderActiveTab()}

        {popoverState && (
          <DataEntryPopover
            x={popoverState.x}
            y={popoverState.y}
            onClose={() => setPopoverState(null)}
            onSave={handlePopoverSave}
            parameterType={popoverState.parameterType}
            currentValue={getCurrentValueForPopover()}
          />
        )}
      </div>
    </div>
  );
};

export default DentalChartingScreen;
